import * as React from 'react';
import {Col, Row} from 'react-bootstrap';
import './style.scss';
import {Link} from 'react-router-dom';
import {Field} from 'redux-form';
import FieldFormControl from '../../../../components/FieldFormControl';
import {isNotFalse, isRequired} from '../../../../util/validators';

interface ISignpost {
  bespokeMedical?: boolean;
  medical?: boolean;
  type?: SignpostType;
  callCenter?: boolean;
  withCheckbox?: boolean;
  checkBoxFormPath?: string;
  withLink?: boolean;
}

export const enum SignpostType {
  TYPE_A = 'A',
}

class Signposting extends React.Component<ISignpost> {

  private renderContent = () => {
    const {medical, callCenter, withLink, bespokeMedical} = this.props;
    if (medical) {
      return this.renderMedicalDeclineContent(bespokeMedical);
    } else if (callCenter) {
      return this.renderContactCallCenterContent(withLink);
    } else {
      return this.renderMedicalOverThresholdContent();
    }
  }

  private renderConfirmCheckbox = () => {
    const {checkBoxFormPath} = this.props;
    return (
      <Row>
        <Col xs={12}>
          <Field
            name={checkBoxFormPath}
            type="checkbox"
            value="true"
            component={FieldFormControl}
            validate={[isRequired, isNotFalse]}
          >
            <div/>
            Please confirm that you have read and understood the information above.
          </Field>
        </Col>
      </Row>
    );
  }

  private renderDirectoryDetailsForMedicalThreshold = (decline = false) => {
    return (
      <div>
        <p>
          MoneyHelper makes it easier to find and compare policies you can afford that cover your condition and medical
          needs.
        </p>
        <p className="">
          Access the <a target={'_blank'}
                        href={'https://www.moneyhelper.org.uk/en/everyday-money/insurance/use-our-travel-insurance-directory'}>
          MoneyHelper directory online
        </a> or call MoneyHelper on 0800 138 7777 (phone lines are open Monday to Friday
          8.00am – 6.00pm, excluding bank holidays).
        </p>
        <p>
          To request the directory details in writing,
          please <a target={'_blank'} href={'https://eforms.admiral.com/travel-medical-' + (decline ? 'decline' : 'load')}>click here</a>.
        </p>
      </div>
    );
  }

  private renderMedicalDeclineContent = (bespokeMedical = false) => {
    const {type} = this.props;
    let component = null;
    switch (type) {
      case SignpostType.TYPE_A:
        component = (
          <Row className="medical-decline">
            <Col xs={12} style={{padding: '10px'}}>
                <>
                  <p>
                    We're sorry, we can't give you a quote right now. That's because of the medical information you've provided. We understand this may be disappointing but don't worry - there's help available.
                  </p>
                  <p>
                    Find an insurer that's right for you with MoneyHelper.<br/>
                    The MoneyHelper Directory can help you find insurers who specialise in medical conditions. They may be able to help as you've had travel insurance refused or had it cancelled.
                  </p>
                  <p>MoneyHelper makes it easier to find and compare policies that are right for you.</p>
                  <p>
                    Find the {' '}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.moneyhelper.org.uk/en/everyday-money/insurance/use-our-travel-insurance-directory"
                    >
                      MoneyHelper Directory
                    </a>{' '}
                    online or call them on 0800 138 7777. Phone lines are open Monday to Friday, 8am - 6pm, excluding bank holidays.
                  </p>
                  <p>Prefer details in writing? Click <a target={'_blank'} href={'https://eforms.admiral.com/travel-medical-decline'}>here</a></p>
                </>
            </Col>
          </Row>
        );
        break;
    }

    return component;
  }

  private renderMedicalOverThresholdContent = () => {
    const {type, withCheckbox} = this.props;
    let component = null;

    switch (type) {
      case SignpostType.TYPE_A:
        component = (
          <div className="medical-threshold">
            <div className="content">
              <div className="title">PLEASE NOTE:</div>
              <p>
                Your quote includes an additional premium due to the medical information provided.
              </p>
              <p>
                You can use the <a target={'_blank'}
                                   href={'https://www.moneyhelper.org.uk/en/everyday-money/insurance/use-our-travel-insurance-directory'}>
                MoneyHelper directory
              </a> to find a specialist insurer who might be able to cover you if you’ve been:
                <ul style={{paddingLeft: '20px'}}>
                  <li>refused travel insurance or had your policy cancelled</li>
                  <li>offered cover with a medical exclusion that you can’t remove from your policy</li>
                  <li>quoted a price for a travel insurance policy with high medical costs</li>
                </ul>
              </p>
              {this.renderDirectoryDetailsForMedicalThreshold()}
              {withCheckbox && (
                <>
                  {this.renderConfirmCheckbox()}
                </>
              )}
            </div>
          </div>
        );
        break;
    }
    return component;
  }

  private renderContactCallCenterContent = (withLink = true) => {
    return (
      <>
        <div className="call-center">
          <div>
            <h3 className="title">WHOOPS!</h3>
            <p>
              Unfortunately, we have been unable to make the change you have requested.
            </p>
            <p>
              Please contact us in order to make the change and keep your policy up to date. Details on how to contact
              us can be found <a target={'_blank'} href={'https://www.admiral.com/contact-us/travel'}> here </a>
            </p>
            <p>
              It is important that your details are kept up to date, as incorrect information could invalidate your
              cover or affect any future claims.
            </p>
          </div>
        </div>
        {withLink && (
          <div className="return-to-account-btn mt-15">
            <Link to={`/account/policies`}>
              Return to Policies
            </Link>
          </div>
        )}
      </>
    );
  }

  public render() {
    return (
      <>
        {this.renderContent()}
      </>
    );
  }

}

export default Signposting;
